/*
 * `?page=N` for the paged list screens (rankings), shareable and walked by the
 * browser's back button. The legacy site named the param per list
 * (`page_players` on /player/top, `page_points` on the season pages); passing
 * that name as `legacyKey` lets old inbound links land on the right page, and
 * the first navigation rewrites them to `page`.
 */

export const PAGE_PARAM = 'page';

function positiveInt(raw: string | null): number | null {
  if (raw === null || !/^\d+$/.test(raw)) return null;
  const parsed = Number(raw);
  return Number.isSafeInteger(parsed) && parsed > 0 ? parsed : null;
}

/** The 1-based page the URL asks for; anything but a positive integer is page 1. */
export function readPage(params: URLSearchParams, legacyKey?: string): number {
  return (
    positiveInt(params.get(PAGE_PARAM)) ??
    (legacyKey ? positiveInt(params.get(legacyKey)) : null) ??
    1
  );
}

/**
 * A copy of `params` pointing at `page`: page 1 drops the param (one canonical
 * URL per list), and the legacy alias always goes.
 */
export function withPage(
  params: URLSearchParams,
  page: number,
  legacyKey?: string,
): URLSearchParams {
  const next = new URLSearchParams(params);
  if (legacyKey) next.delete(legacyKey);
  if (page > 1) next.set(PAGE_PARAM, String(page));
  else next.delete(PAGE_PARAM);
  return next;
}
